// ======================================================================
// File Name       : document
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/content';

const initialState = {
  filterData: {
    contentSecernIdList: [],
    contentSecernIds: '',
    contentName: '',
    documentUpdateStatus: null,
    createdDateFrom: null,
    createdDateTo: null,
    dataAffiliationType: '-1',
    contentSortType: null,
    ascendingDescendingSort: null,
    startPosition: 0,
  },
  recordNum: 0,
  documentContentList: {
    allSecernIds: [],
    bySecernId: {},
  },
  csvFileLink: '',
  documentContentInfo: {
    contentSecernId: '',
    contentName: '',
    documentUpdateStatus: '',
    imageUrl: '',
    documentName: '',
    createdAt: '',
    updatedAt: '',
    noRecordFound: false,
  },
  documentContentRegisterInfo: {
    contentSecernId: '',
    contentName: '',
    documentUpdateStatus: '',
    imageUrl: '',
    documentName: '',
    createdAt: '',
    updatedAt: '',
    noRecordFound: false,
  },
  registerSuccess: false,
  editSuccess: false,
};

export default function document(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.CONTENT_DOCUMENT_LIST: {
      const { contentDocumentList } = action;
      const recordNum = contentDocumentList.recordNum;
      const csvFileLink = contentDocumentList.csvfileUrl;
      const documentContentList = contentDocumentList.documentContentList.reduce(
        (acc, cur) => {
          const { contentSecernId } = cur;
          acc.bySecernId[contentSecernId] = cur;
          acc.allSecernIds.push(contentSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
          recordNum,
          csvFileLink,
        },
      );
      return { ...state, ...{ documentContentList } };
    }
    case ActionTypes.CONTENT_DOCUMENT_REGISTER: {
      const { documentContentRegisterInfo } = initialState;
      return {
        ...state,
        documentContentRegisterInfo,
        registerSuccess: true,
      };
    }
    case ActionTypes.CONTENT_DOCUMENT_DETAIL: {
      const { documentContentInfo } = action;
      return {
        ...state,
        documentContentInfo,
      };
    }
    case ActionTypes.CONTENT_DOCUMENT_EDIT: {
      const { documentContentInfo } = initialState;
      return {
        ...state,
        documentContentInfo,
        editSuccess: true,
      };
    }
    default: {
      const { documentContentRegisterInfo, filterData } = initialState;
      return {
        ...state,
        documentContentRegisterInfo,
        editSuccess: false,
        registerSuccess: false,
        filterData,
      };
    }
  }
}
